<script setup lang="ts">
import type { BlockRootContext } from '#layers/block-engine/public';
import { reactiveComputed } from '@vueuse/core';
import { computed } from 'vue';
import { useWorkspaceSchemaStore } from '#layers/data-model/public';
import PageShellBlank from '#layers/ui-workspace/components/PageShell/Blank.vue';
import PageShellCollectionDetailFooter from '#layers/ui-workspace/components/PageShell/CollectionDetail/CollectionDetailFooter.vue';
import PageShellCollectionDetailHeader from '#layers/ui-workspace/components/PageShell/CollectionDetail/CollectionDetailHeader.vue';

const props = defineProps<{
	context: BlockRootContext;
}>();

const { findCollectionById } = useWorkspaceSchemaStore();

const detailPageContext = reactiveComputed(() => props.context);
const collection = computed(() => detailPageContext.collectionId ? findCollectionById(detailPageContext.collectionId) : undefined);

// Full-page detail view; drawers and modals render their own chrome instead
const isFullPage = computed(() => !detailPageContext.pageDisplayMode);

const respectSafeArea = computed(() => detailPageContext.pageDisplayMode === 'drawer');
</script>

<template>
	<div class="flex h-full flex-col" :class="{ 'pb-safe': respectSafeArea }">
		<PageShellCollectionDetailHeader
			v-if="!!collection && isFullPage"
			:collection
			:back-route="detailPageContext.backRoute"
			:dismiss-action="detailPageContext.dismissAction"
		/>
		<div class="relative min-h-0 flex-1">
			<PageShellBlank :context class="h-full overflow-auto">
				<slot />
			</PageShellBlank>
		</div>
		<PageShellCollectionDetailFooter v-if="!isFullPage" />
	</div>
</template>
